import styled from 'styled-components';

export const AppBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  padding-bottom: 24px;
`;
export const Loader = styled.div`
  margin-left: auto;
  margin-right: auto;
`;
export const ButtonContainer = styled.div`
  display: flex;
`;
